import { useUserSession } from '@solinkcorp/authentication';
import CloudAiApi from 'clients/CloudAiApi';
import useSWR from 'swr';

export type UseEventSpotCheckStructuredOutput = ReturnType<
  typeof useEventSpotCheckStructuredOutput
>;

export function useEventSpotCheckStructuredOutput(message?: string) {
  const userSession = useUserSession();
  const eventSpotCheckStructuredOutput = useSWR(
    message ? `event-spot-check-structured-output-${message}` : null,
    () => CloudAiApi.getEventSpotCheckStructuredOutput(userSession.accessToken, message as string),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
    },
  );

  return eventSpotCheckStructuredOutput;
}
